__turbopack_context__.v({
  "chevron": "_8qBP5W_chevron",
  "chip": "_8qBP5W_chip",
  "chipsWrap": "_8qBP5W_chipsWrap",
  "count": "_8qBP5W_count",
  "disclaimer": "_8qBP5W_disclaimer",
  "dot": "_8qBP5W_dot",
  "expandContent": "_8qBP5W_expandContent",
  "expandRow": "_8qBP5W_expandRow",
  "expanded": "_8qBP5W_expanded",
  "inactive": "_8qBP5W_inactive",
  "open": "_8qBP5W_open",
  "rowHeader": "_8qBP5W_rowHeader",
  "rowLabel": "_8qBP5W_rowLabel",
  "slideDown": "_8qBP5W_slideDown",
  "summary": "_8qBP5W_summary",
  "thumb": "_8qBP5W_thumb",
  "wrapper": "_8qBP5W_wrapper",
});
